import React from 'react';
import { cn } from '../../lib/utils';
import { Loader2 } from 'lucide-react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
}

export default function Button({ variant = 'primary', size = 'md', isLoading, className, children, disabled, ...props }: ButtonProps) {
  const variants: Record<string, string> = {
    primary: 'd-btn-primary',
    secondary: 'd-btn-secondary',
    danger: 'd-btn-danger',
    ghost: 'd-btn-ghost',
  };
  const sizes: Record<string, string> = { sm: 'd-btn-sm', md: '', lg: 'd-btn-lg' };
  return (
    <button className={cn(variants[variant], sizes[size], className)} disabled={disabled || isLoading} {...props}>
      {isLoading && <Loader2 className="w-4 h-4 animate-spin" />}
      {children}
    </button>
  );
}
